module.exports = __webpack_public_path__ + "static/media/calendarDisabled.84a2dff3.svg";